import React from 'react';
import PropTypes from 'prop-types';
import { FlagBlock } from 'anf-core-react';

const getAddressCardForHK = (address) => (
  <>
    {address?.orgName ? (
      <p data-testid="orgName">
        {address?.orgName}
      </p>
    )
      : (
        <p data-testid="name">
          {`${address?.lastName} ${address?.firstName}`}
        </p>
      )}
    <p id="shipping-address-1" data-testid="address">{address?.address1}</p>

    {address?.address2 && <p id="shipping-address-2" data-testid="address">{address?.address2}</p>}
    <p data-testid="city-state-postal">
      {address?.state && <span data-testid="state">{`${address?.state}, `}</span>}
      <span data-testid="district">{address?.district}</span>
    </p>

  </>
);

const getAddressCardForJP = (address) => (
  <>
    {address?.orgName ? (
      <p data-testid="orgName">
        {address?.orgName}
      </p>
    )
      : (
        <p data-testid="name">
          {`${address?.lastName || ''} ${address?.firstName || ''} ${address?.phoneticName || ''}`}
        </p>
      )}
    <p data-testid="city-state-postal">
      {address?.state && <span data-testid="state">{`${address?.state}, `}</span>}
      <span data-testid="city">{`${address?.city}, `}</span>
    </p>
    <p id="shipping-address-1" data-testid="address">{address?.address1}</p>

    {address?.address2 && <p id="shipping-address-2" data-testid="address">{address?.address2}</p>}
    <span data-testid="postalCode">{address?.postalCode}</span>
  </>
);

const geAddressCard = (address) => {
  switch (address?.country) {
    case 'HK':
      return getAddressCardForHK(address);
    case 'JP':
      return getAddressCardForJP(address);
    default:
      return (
        <>
          {address?.orgName ? (
            <p data-testid="orgName">
              {address?.orgName}
            </p>
          )
            : (
              <p data-testid="name">
                {`${address?.firstName} ${address?.lastName}`}
              </p>
            )}
          <p id="shipping-address-1" data-testid="address">{address?.address1}</p>

          {address?.address2 && <p id="shipping-address-2" data-testid="address">{address?.address2}</p>}
          <p data-testid="city-state-postal">
            {address?.city && (
              <span data-testid="city">
                {`${address?.city}, `}
              </span>
            )}
            {address?.state && <span data-testid="state">{`${address?.state}, `}</span>}
            <span data-testid="postal-code">{address?.postalCode}</span>
          </p>
        </>
      );
  }
};

function SavedAddressCard({ address, isCountryFlagVisible }) {
  if (!address) {
    return null;
  }
  return (
    <>
      {geAddressCard(address)}
      {isCountryFlagVisible && address.country
        && (
          <FlagBlock
            countryCode={address.country}
            countryName={address.country}
          />
        )}
    </>
  );
}

SavedAddressCard.propTypes = {
  address: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    sameDayStoreId: PropTypes.string,
    addressId: PropTypes.string,
    country: PropTypes.string,
    isAddressVerified: PropTypes.bool,
    email: PropTypes.string,
    isBillingAllowed: PropTypes.bool,
    isDefaultBilling: PropTypes.bool,
    isDefaultShipping: PropTypes.bool,
    isShippingAllowed: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    orgName: PropTypes.string,
    pickUpStoreId: PropTypes.string,
    poBox: PropTypes.bool,
    title: PropTypes.string,
    zone: PropTypes.string,
    district: PropTypes.string,
    prefecture: PropTypes.string,
  }),
  isCountryFlagVisible: PropTypes.bool,
};

SavedAddressCard.defaultProps = {
  isCountryFlagVisible: false,
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    isCountryFlagVisible: false,
    firstName: '',
    lastName: '',
    sameDayStoreId: '',
    country: '',
    isAddressVerified: false,
    email: '',
    isBillingAllowed: false,
    isDefaultBilling: false,
    isDefaultShipping: false,
    isShippingAllowed: false,
    orgName: '',
    pickUpStoreId: '',
    poBox: false,
    title: '',
    zone: '',
    district: '',
    prefecture: '',
  },
};
export default SavedAddressCard;
